import '../styles/fonts.css';
import Sidebar from '../components/Sidebar.jsx';
import PageHeader from '../components/PageHeader.jsx';
import Slider from '../components/Slider.jsx';


const Engineering = () => {
    let coverPic = 'https://static.igem.wiki/teams/5066/global/bgpic.png';
    let fig1 = 'https://static.igem.wiki/teams/5066/wetlab/fig-1-dblt-cycle.png';  
    let fig2 = 'https://static.igem.wiki/teams/5066/wetlab/fig-2-construct.png';
    let fig3 = 'https://static.igem.wiki/teams/5066/hardware/figure-3-final-ver.png';
    let fig4 = 'https://static.igem.wiki/teams/5066/wetlab/fig-4-colony-pcr-basic-part.png';
    let fig5 = 'https://static.igem.wiki/teams/5066/wetlab/fig-5-no-stop-basic-part.png';
    let fig6 = 'https://static.igem.wiki/teams/5066/hardware/figure-8-final-ver.png';
    let fig7 = 'https://static.igem.wiki/teams/5066/wetlab/fig-7-colony-pcr-composite-part.png';
    let fig8 = 'https://static.igem.wiki/teams/5066/wetlab/finalengsuc.png';
    let fig9 = 'https://static.igem.wiki/teams/5066/wetlab/final-eng1.png';
    let fig11 = 'https://static.igem.wiki/teams/5066/wetlab/final-eng3.png';
    let fig12 = 'https://static.igem.wiki/teams/5066/wetlab/final-eng4-0.png';
    let fig13 = 'https://static.igem.wiki/teams/5066/hardware/figure-5-final-ver.png';
    let fig14 = 'https://static.igem.wiki/teams/5066/hardware/figure-6-final-ver.png';
    let fig15 = 'https://static.igem.wiki/teams/5066/hardware/construct-his-tag.png'

    let sections = [
        { id: 's1', name: 'Vector Design' },
        { id: 's2', name: 'Plasmid Construct Designs' },
        { id: 's3', name: 'DBTL Cycle' },
        { id: 's4', name: 'Cycle 1' },
        { id: 's5', name: 'Cycle 2' },
        { id: 's6', name: 'Cycle 3' },
        { id: 's7', name: 'Acknowledgements' },
        { id: 's8', name: 'References' },
    ];
    const images = [
        { path: 'https://static.igem.wiki/teams/5066/wetlab/flow2.gif' },
        { path: 'https://static.igem.wiki/teams/5066/wetlab/flow3.gif' },
        { path: 'https://static.igem.wiki/teams/5066/wetlab/flow4.gif' },
        { path: 'https://static.igem.wiki/teams/5066/wetlab/flow5.gif' },
        { path: 'https://static.igem.wiki/teams/5066/wetlab/flow6-1.gif' },
        { path: 'https://static.igem.wiki/teams/5066/wetlab/flow7.gif' },
    ];


    return (
        <div className='bg-[#fef9e3]'>
            <PageHeader img={coverPic} title={'Engineering'} customPicture={<img src={'https://static.igem.wiki/teams/5066/cover/software.gif'} alt="Custom" className="w-44 h-44" />}
            />


            <div className='flex bg-gradient-to-b from-[#fef9e3] via-[#e8f3f7] to-[#feedfb]'>
                <Sidebar sections={sections} />

                {/* Main Content */}
                <div className='flex-col w-full lg:p-[50px] p-[5px] my-[10px] space-y-16 rounded-2xl bg-white shadow-[-2px_4px_8px_-2px_rgba(0,0,0,0.2)]'>
                    
                    <img src={fig8} alt='eng_img' className='mx-auto w-[600px] h-auto'></img>
                    <br></br>
                    <section id='s1'>
                        <h2 className='text-3xl font-bold text-[#C94C67]'>
                    Vector Design                        
                        </h2>
                    <div className='w-[700px] h-auto'>
                    <Slider images={images}/>  
                    </div>
                    </section>
                    <br/>
                    <section id='s2'>
                        <h2 className='text-3xl font-bold text-[#C94C67]'>
                            Plasmid Construct Designs
                        </h2>
                        <p className='ml-5 mt-8 text-xl'>
                        Construct 1:
                        </p>
                        <img src={fig9} alt='eng_img' className='w-3/4 mx-auto'></img>
                        <p className='ml-5 mt-8 text-xl'>
                        Construct 2:
                        </p>
                        <img src={fig15} alt='eng_img' className='w-3/5 mx-auto'></img>
                        <p className='ml-5 mt-8 text-xl'>
                        Construct 3:
                        </p>
                        <img src={fig11} alt='eng_img' className='w-3/4 mx-auto'></img> 
                        <p className='ml-5 mt-8 text-xl'>
                        Construct 4:
                        </p> 
                        <img src={fig12} alt='eng_img' className='w-3/5 mx-auto'></img>
                     </section>                       
                    <br>
                    </br>
                    <div className='pb-12'>
                        <section id='s3' className='pb-12'>
                            <h2 className='text-3xl font-bold text-[#C94C67]'>
                            Design-Build-Test-Learn (DBTL) cycle
                            </h2>
                            <p className='mb-2 mt-4 ml-5 text-xl font-bold text-[#C94C67]'>
                                Overview
                            </p>
                            <p className='ml-5 mb-2'>
                            Our project aims to produce a combination of different biolarvicidal toxins in a chromosome-free system to solve arthropod-borne diseases, especially dengue. Even though our project specifically targets dengue, the biolarvicidal proteins could also act on other mosquito species, such as <span className='italic'>Culex spp.</span> (Dylo et al., 2014) and <span className='italic'>Anopheles spp</span>. (Liu et al., 2023). The biolarvicidal toxins that we want to synthetically produce will be highly specific and safe, targeting only mosquito larvae while not affecting other organisms. We aim to produce all our biolarvicidal toxins in a chromosome-free system, as reported by Japan-United, the Grand Prize winner of iGEM 2023.

                            </p>
                            <p className='ml-5 mb-2'>
                            We follow Design-Build-Test-Learn (DBTL) cycles to conduct our cloning process. DBTL cycles help us continuously improve and optimize our cloning strategies to enhance the efficacy of biolarvicidal toxins and the production of a chromosome-free system.
                            </p>
                            <img
							src={fig1}
							alt='softwarePic'
							className='w-2/5 mx-auto h-auto'
						    />
                            <p className='ml-10 text-center mb-4'>
                            Figure 1. DBTL cycle of our project
                            </p>
                        </section>
                        <section id='s4' className='pb-12'>
                            <h2 className='text-3xl font-bold text-[#C94C67]'>
                            Cycle 1 - Basic parts optimization
                            </h2>
                            <p className='mb-2 mt-2 ml-5 text-xl font-bold text-[#C94C67]'>
                                Design 1
                            </p>
                            <p className='ml-5 mb-2'>
We used pET-28a as our cloning vector, which includes a T7 promoter, ribosomal binding site, and a Lac operator (Shilling et al., 2020). The fragments (Cyt2Ba, Xpp81Aa1, Cry2Aa, BmK IT1, Vip3Aa, and BBa_K4955002) and the primers were designed using NEBuilder HiFi DNA Assembly in SnapGene. These fragments and primers were optimized and synthesized through Integrated DNA Technologies (IDT).
                            </p>
                            
                            <img
							src={fig2}
							alt='softwarePic'
							className='w-3/4 mx-auto h-auto'
						/>
                            <p className='ml-10 text-center mb-4'>
Figure 2. Constructs design using NEBuilder HiFi DNA assembly tool in SnapGene.
                            </p>
                            <p className='mb-2 mt-2 ml-5 text-xl font-bold text-[#C94C67]'>
                                Build 1
                            </p>
                            
                            <p className='ml-5 mb-2'>
                            We linearized the pET-28a vector using restriction enzymes and assembled the overlapping extended fragments with the vector following the HiFi DNA assembly protocol. The ligated plasmids were then transformed into DH5α Escherichia coli cells. Colonies were screened using colony PCR, and the band sizes were confirmed through gel electrophoresis and DNA sequencing.
                            </p>
                            <p className='ml-5 mb-2'>
                            We successfully produced Cyt2Ba, Xpp81Aa1, BmK IT1, Vip3Aa, and BBa_K4955002 clones. However, despite multiple optimizations of the PCR conditions and program, we could not amplify Cry2Aa using PCR overlapping extension. We suspect this is due to the secondary structure formation in the template DNA or primers, as strong primer dimers were observed in gel electrophoresis.                            </p>
                        <img
                            src={fig3}
                            alt='softwarePic'
                            className='w-2/5 mx-auto h-auto'
                        />
                        <p className='ml-10 text-center mb-4'>
Figure 3.  DNA gel electrophoresis of the Cry2Aa fragment following overlap extension PCR.  </p>
                   
                            <p className='mb-2 mt-2 ml-5 text-xl font-bold text-[#C94C67]'>
                                Test 1
                            </p>
                            <p className='ml-5'>
The correct plasmids were extracted through miniprep and subsequently transformed into BL21(DE3) <em>E. coli</em> cells for recombinant protein expression. IPTG was added to BL21(DE3) competent <em>E. coli</em> cells to induce recombinant protein expression. Different temperatures and time points were used for bacterial culture to determine the optimal growth conditions for recombinant protein expression. The bacterial growth rates under these varying conditions were recorded and analyzed. The pellets were collected for SDS-PAGE and larvicidal assays. Details on larvicidal assay can be found in “proof of concept”.

                            </p>
                            <img
                            src={fig4}
                            alt='softwarePic'
                            className='w-3/4 mx-auto text-center h-auto'
                        />
                        <p className='ml-10 mb-4'>
Figure 4. Colony PCR was performed to identify the presence of fragments with overlapping sequences. All fragments were observed at the expected size bands (Cyt2Ba: 822bp, Xpp81Aa1: 1164bp, BBa_K4955002: 1107bp, BmK IT1: 297bp, Vip3Aa: 2400bp) 
 </p>
                        <p className='ml-5'>
                        After we performed colony PCR for each fragment, we sent either the colony or PCR product for sequencing. All the sequencing results will be available upon request.                        </p>
                        <p className='ml-5 mt-2'>
                        We successfully produced clones of pET-28a-Cyt2Ba, pET-28a-Xpp81Aa1, and pET-28a-BmK IT1.
                        </p>
                            
                            <p className='mb-2 mt-2 ml-5 text-xl font-bold text-[#C94C67]'>
                                Learn 1
                            </p>
                            <p className='ml-5'>
                            We learned that different PCR and DNA assembly conditions can affect fragment amplification and DNA assembly. During Build 1, we conducted multiple troubleshooting steps by adjusting the amounts of primers and templates, as well as the PCR reaction program, all of which are documented in our lab notebook.

                            </p>
                           
                            <p className='ml-5 mb-2 mt-4'>
                            Moreover, we realized that our plasmid design includes stop codons at the end of the protein-coding sequences, preventing the production of proteins linked to the His-tag. As a result, we were unable to detect the recombinant proteins using Western blotting against the His-tag. However, we would only perform SDS-PAGE with Coomassie blue staining to identify protein expression (Figure 5 and 6). The results did not clearly show the increased protein expression using SDS-PAGE with Coomassie blue staining. Therefore, we redesigned the fragments to remove the stop codons and detected using Western blotting.

                           </p>
                           <img
                            src={fig13}
                            alt='softwarePic'
                            className='w-3/4 mx-auto h-auto'
                        />
                        <p className='ml-10 text-center mb-4'>
                        Figure 5. SDS-PAGE with Coomassie blue staining.(A) Cyt2Ba was induced with 1 mM IPTG at 20°C overnight, compared to a non-induced control. Lysate (L) and supernatant (S) were collected after lysis for examination. (B) Cyt2Ba was induced with 1 mM IPTG at 37°C 4hr and  37°C overnight, compared to a non-induced control. Red box and arrow indicate the expected band sizes.
                         </p>
                                                    <img
                            src={fig14}
                            alt='softwarePic'
                            className='w-3/4 mx-auto h-auto'
                        />
                        <p className='ml-10 text-center mb-4'>
                        Figure 6. SDS-PAGE with Coomassie blue staining. (A) BmK IT1 was induced with 1 mM IPTG at 37°C overnight, compared to a non-induced control. Different lysis buffer dilutions were used. (B) Vip3Aa was induced with 1 mM IPTG at 37°C 4hr, compared to a non-induced control.
                         </p>
                                                   
                        </section>
                        <section id='s5' className='pb-12'>
                            <h2 className='text-3xl font-bold text-[#C94C67]'>
                            Cycle 2 - Basic parts without stop codon
                            </h2>
                            <p className='mb-2 mt-2 ml-5 text-xl font-bold text-[#C94C67]'>
                                Design 2
                            </p>
                            <p className='ml-5 mb-2'>
To resolve the expression issue, we removed the stop codon at the end of the protein-coding sequences and fused a 6x His-tag to ensure that transcription continues and expression occurs during translation. We redesigned the fragments by removing stop codons at the end of their protein-coding sequences.

                            </p>
                            
                            <p className='mb-2 mt-2 ml-5 text-xl font-bold text-[#C94C67]'>
                                Build 2
                            </p>
                            <p className='ml-5'>
Similar to the first building process, we successfully assembled the fragments that were fused with a 6x His-tag into the pET-28a vector and transformed them into DH5α and BL21 <em>E. coli</em> cells for plasmid and protein production, respectively. Colony PCR and DNA sequencing were performed to confirm that the correct plasmids were produced and expressed. All the sequencing results will be available upon request.  
                            </p>
                        <img
                            src={fig5}
                            alt='softwarePic'
                            className='w-3/4 mx-auto text-center h-auto'
                        />
                        <p className='ml-10 mb-4 text-center'>
Figure 7. Colony PCR was performed to identify the presence of pET-28a-Cyt2Ba and pET-28a-Xpp81Aa without stop codon that transformed into DH5ɑ <em>E. coli</em>.
                        </p>
                        <p className='mb-2 mt-4 ml-5 text-xl font-bold text-[#C94C67]'>
                                Test 2
                            </p>
                        
                            <p className='ml-5'>
We performed the same BL21(DE3) <em>E. coli</em> growing conditions as Test 1. We successfully produced clones of pET-28a-BBa_K4955002 and, pET-28a-Cyt2Ba, and pET-28a-BmK IT1 without a stop codon. 
                            </p>
                            <p className='ml-5'>
After IPTG induction, we collected the pellets and lysed the cells for Western blotting. Additionally, we co-transformed Cyt2Ba and BBa_K4955002 into BL21(DE3) <em>E. coli</em> cells and induced protein expression by adding crystal violet (CV) on agar plates, following the protocol established by iGEM23_Japan-United.
                            </p>
                         <img
                            src={fig6}
                            alt='softwarePic'
                            className='w-3/5 mx-auto h-auto'
                        />
                        <p className='ml-10 text-center mb-4'>
Figure 8. Western blot analysis was performed to detect His-tagged proteins.
Lane 1: pET-28a-Xpp81Aa1 without IPTG; Lane 2: <em>E. coli </em>E BL21 (DE3) cells with pET-28a-Xpp81Aa1  incubated with 1mM IPTG; Lane 2: pET-28a-Xpp81Aa1 without IPTG; Lane 3: pET-28a-Cyt2Ba without IPTG; Lane 4: pET-28a-Cyt2Ba incubated with 1mM IPTG; Lane 5: pET-28a-Bmk without IPTG; Lane 6: pET-28a-Bmk with 1mM IPTG.</p>
                            
                            <p className='mb-2 mt-4 ml-5 text-xl font-bold text-[#C94C67]'>
                                Learn 2
                            </p>
                            
                            <p className='ml-5 mb-2'>
                            The proof of concept through larvicidal assays showed that the pellets we produced are suitable for use as bioinsecticides. Therefore, we are moving forward with the design of composite fragments that will allow us to combine the effects of the different Bti toxins and neurotoxins.                            </p>
                        </section>
                        <section id='s6' className='pb-12'>
                            <h2 className='text-3xl font-bold text-[#C94C67]'>
                                Cycle 3 - Composite of 2 and 3 fragments
                            </h2>
                            <p className='mb-2 mt-2 ml-5 text-xl font-bold text-[#C94C67]'>
                                Design 3
                            </p>
                            <p className='ml-5 mt-2'>
                            At this stage, we had successfully cloned several recombinant biolarvicidal toxins. However, we continued to ask ourselves whether we had done enough in the field of vector control. Would our work be able to solve arthropod-borne diseases?

                            </p>
                            <p className='ml-5 mt-4'>
                            With only a handful of recombinant biolarvicidal toxins, we knew we could not achieve our aspiration to end dengue by 2030. At the same time, we were planning to design a few composites to allow us to synthetically produce more biolarvicidal toxins to help us achieve our project’s aim. However, we did not know how to design and build a composite.
                            </p>
                            <p className='ml-5 mt-4'>
                            Hence, we extensively studied past iGEM projects and tried to figure out how to assemble two or three fragments together. We also conducted in-depth research on biolarvicidal proteins and came across a website called ‘Pesticidal Proteins.’ We studied the work done by various scientists around the world on this topic.
                                                        </p>
                            <p className='ml-5 mt-4'>
                            This website inspired much of our research as it compiled various families of pesticidal proteins that could act as larvicides or adulticides. We contacted Prof. Dr. Neil Crickmore at the University of Sussex, one of the primary investigators of the website. We were glad and thankful that Professor Crickmore replied to us and addressed some of the prospects and challenges of synthetic biolarvicides. Most importantly, Professor Crickmore selflessly took the time to help us troubleshoot the technical problems we had encountered. He shared tips for assembly, a sequence of ribosomal binding sites (RBS) and linkers, as well as cloning techniques.
                                                        </p>
                            <p className='ml-5 mt-4'>
                            Following the conversation with Professor Crickmore and extensive research on linking fragments, we gained insight into how to link two or three fragments together. We then knew we needed a strong RBS. We referred to the registry and past iGEM teams and found BBa_B0030, a strong RBS to use for our project.

                            </p>
                            <p className='ml-5 mt-4'>
                            Through the research study done by our team, we learned that insecticide resistance was becoming increasingly problematic and prominent in many Southeast Asian countries, where dengue fever is prevalent. Therefore, we thought that combining Bt toxins and scorpion toxins was a promising strategy that could provide an additional layer of protection against insecticide resistance.
                            </p>
                            <p className='ml-5 mt-4'>
                            In addition, Xpp81Aa1 enhanced the toxicity of Bt's Cry proteins, resulting in a lower concentration of toxins needed to reach LC<sub class="text-sm align-text-bottom">90</sub> (Wu et al., 2021). Given the structural similarities among Cyt, Vip, and Cry proteins, we aimed to explore various combinations of these proteins to assess their potential synergistic effects. We attempted to synthesize the composite of 2 or 3 fragments by assembling different basic parts with ribosomal binding sites and a 6x His-tag.

                            </p>
                            <p className='ml-5 mt-4'>
                            Research reported that p20, a 20-kilodalton protein, acted as a chaperone in Bt strains that facilitated the crystal formation of various insecticidal proteins by promoting their proper folding. We combined our fragments with p20 to promote proper protein folding and increase protein expression (Shi, Tang, Liao, & Xu, 2017).
                            
                            </p>
                            <p className='ml-5 mt-4'>
                            We then proceeded to design our composite. We optimized and synthesized the composite fragments through IDT and Twist Bioscience. We designed a total of 2 composites that combined three fragments, such as p20-Cyt2Ba-Xpp81Aa1 and p20-Cyt2Ba-BmK IT1. The company reported that our construct failed to assemble, as it may have contained mis-assembly due to the existence of long repeats in the sequences. Hence, we outsourced a composite of three fragments to GenScript. Though we outsourced the design of p20-Cyt2ba-Xpp81Aa1, we cloned, transformed, and sequenced pETDUET-1-p20-Cyt2Ba-Xpp81Aa1.
                            </p>
                            <p className='mb-2 mt-4 ml-5 text-xl font-bold text-[#C94C67]'>
                                Build 3
                            </p>
                            <p className='ml-5 mb-2'>
                            The process of cloning was similar to the first and second building processes. With our prior cloning experience and the adjustments made in previous DBTL cycles, all composite parts that we had designed were successfully cloned.                            </p>
                            <p className='mb-2 mt-2 ml-5 text-xl font-bold text-[#C94C67]'>
                                Test 3
                            </p>
                            <p className='ml-5 mb-2'>
We successfully produced clones of BmK IT1-Xpp81Aa1, BmK IT1-Cyt2Ba, p20-Cyt2Ba, Xpp81Aa1-Cyt2Ba and Cyt2Ba-p20-Xpp81Aa1. 
                            </p>
                            <img
                            src={fig7}
                            alt='softwarePic'
                            className='w-3/4 mx-auto h-auto'
                        />
                         <p className='ml-10 text-center mb-4'>
Figure 9. Colony PCR was performed to identify the presence of composite parts, pET-28a-BmK IT1-Cyt2Ba and pET-28a-Xpp81Aa1-BmK IT1 transformed into DH5ɑ <em>E. coli</em>.
                         </p>
                         <p className='ml-5 text-lg mb-2'>
                         Chromosome-free Crystal Violet

                         </p>
                         <p className='ml-5 mb-2'>
We are using Crystal Violet as an inducer for our chromosome-free system to control the expression of our fragments. In the presence of crystal violet, the restriction enzymes in the bacteria body are produced, therefore removing the chromosomes in the bacteria. Without the chromosome, the bacteria should not be able to reproduce, so when placed onto an agar plate, it should not show any colonies (iGEM, 2023).
                         </p>

                            
                            <p className='mb-2 mt-4 ml-5 text-xl font-bold text-[#C94C67]'>
                                Learn 3
                            </p>
                            <p className='ml-5 mb-2'>
Our team went through three DBTL cycles, and we have learned valuable skills in engineering different BioBricks to form a biological system and achieve our goals. 
                            </p>
                        </section>
                        <section id="s7">
                            <h2 className="text-3xl font-bold text-red-600">Acknowledgement
                            </h2>
                            <p className='ml-5 mt-4'>
Our team would like to express gratitude to Professor Dr. Neil Crickmore, University of Sussex, for sharing knowledge and cloning techniques with us. 
                            </p>
                        </section>
                        <br>
                        </br>
                        <div className='pb-12'>
                            <section id='s8'>
                                <h2 className='text-3xl font-bold text-red-600'>
                                    References
                                </h2>
                                <div className="p-4">
      <ul className="list-none">
        <li className="mb-4">
          Dylo, P., Martin, C., & Mhango, C. (2014). Efficacy of <em>Bacillus thuringiensis</em> var <em>israelensis</em> (Bti) on Culex and Anopheline mosquito larvae in Zomba. <em>Malawi Journal of Science and Technology, 10</em>(1), 40-52. <a href="https://www.ajol.info/index.php/mjst/article/view/105868" className="text-blue-600 underline">https://www.ajol.info/index.php/mjst/article/view/105868</a>
        </li>
        <li className="mb-4">
          iGEM. (2023). <em>Part:BBa K4955002</em>. Retrieved from Igem.org website: <a href="https://parts.igem.org/Part:BBa_K4955002" className="text-blue-600 underline">https://parts.igem.org/Part:BBa_K4955002</a>
        </li>
        <li className="mb-4">
          iGEM. (2003). <em>Part:BBa_B0030</em>. Retrieved from Igem.org website: <a href="https://parts.igem.org/Part:BBa_B0030" className="text-blue-600 underline">https://parts.igem.org/Part:BBa_B0030</a>
        </li>
        <li className="mb-4">
          Liu, L., & Bulla Jr, L. A. (2023). Cell death signaling in <em>Anopheles gambiae</em> initiated by <em>Bacillus thuringiensis</em> Cry4B toxin involves Na+/K+ ATPase. <em>Experimental Biology and Medicine, 248</em>(14), 1191-1205. <a href="https://journals.sagepub.com/doi/full/10.1177/15353702231188072" className="text-blue-600 underline">https://journals.sagepub.com/doi/full/10.1177/15353702231188072</a>
        </li>
        <li className="mb-4">
          Shi, Y., Tang, M., Liao, Y., & Xu, W. (2017). Interactions between molecular chaperone P20 and Cyt2Ba7 toxin in <em>Bacillus thuringiensis</em>. <em>BioRxiv (Cold Spring Harbor Laboratory)</em>. <a href="https://doi.org/10.1101/129833" className="text-blue-600 underline">https://doi.org/10.1101/129833</a>
        </li>
        <li className="mb-4">
          Shilling, P. J., Mirzadeh, K., Cumming, A. J., Widesheim, M., Köck, Z., & Daley, D. O. (2020). Improved designs for pET expression plasmids increase protein production yield in <em>Escherichia coli</em>. <em>Communications Biology, 3</em>(1). <a href="https://doi.org/10.1038/s42003-020-0939-8" className="text-blue-600 underline">https://doi.org/10.1038/s42003-020-0939-8</a>
        </li>
        <li className="mb-4">
          Wu, J., Wei, L., He, J., Fu, K., Li, X., Jia, L., ... Zhang, W. (2021). Characterization of a novel <em>Bacillus thuringiensis</em> toxin active against <em>Aedes aegypti</em> larvae. <em>Acta Tropica, 223</em>, 106088. <a href="https://doi.org/10.1016/j.actatropica.2021.106088" className="text-blue-600 underline">https://doi.org/10.1016/j.actatropica.2021.106088</a>
        </li>
      </ul>
    </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Engineering;
